export const getAppState = (store) => store.app;

export const getAppWidth = (store) => (getAppState(store) ? getAppState(store).width : 0);
export const getScrollTop = (store) => (getAppState(store) ? getAppState(store).scrollTop : 0);
